import { defineMessages } from 'react-intl';

export const scope = 'app.components.ConversationalQuestion';

export default defineMessages({
  objectiveDescription: {
    id: `${scope}.objectiveDescription`,
    defaultMessage: 'Set the AI conversation topic.',
  },
  objectiveTitle: {
    id: `${scope}.objectiveTitle`,
    defaultMessage: 'Objective',
  },
  goalDescription: {
    id: `${scope}.goalDescription`,
    defaultMessage:
      'Define up to {goalLimit} specific goals you want answered.',
  },
  enterGoal: {
    id: `${scope}.enterGoal`,
    defaultMessage: 'Please enter your goal',
  },
  enterObjective: {
    id: `${scope}.enterObjective`,
    defaultMessage: 'Please enter your objective',
  },
  generateGoals: {
    id: `${scope}.generateGoals`,
    defaultMessage: 'Generate goals',
  },
  manyGoalsWarning: {
    id: `${scope}.manyGoalsWarning`,
    defaultMessage:
      'Heads up: a large number of goals increases the time required from respondents.',
  },
  errors: {
    objectiveTooLong: {
      id: `${scope}.errors.objectiveTooLong`,
      defaultMessage: 'Objective is too long',
    },
    objectiveEmpty: {
      id: `${scope}.errors.objectiveEmpty`,
      defaultMessage: 'Whoops! Please type an objective to continue',
    },
    goalTooLong: {
      id: `${scope}.errors.goalTooLong`,
      defaultMessage: 'One or more goal prompts are too long',
    },
    goalEmpty: {
      id: `${scope}.errors.goalEmpty`,
      defaultMessage: 'Please fill out all goals',
    },
    noGoals: {
      id: `${scope}.errors.noGoals`,
      defaultMessage: 'Please add at least one goal to the question',
    },
    tooManyGoals: {
      id: `${scope}.errors.tooManyGoals`,
      defaultMessage: '{max} goals is the maximum allowed limit.',
    },
  },
});
